import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, IconButton } from "@mui/material";

import APP_ROUTES from "../../../../routers/routeConstants";
import AdvertisementCol from "../../../Ads/components/AdvertisementCol";

import { ArrowBackButtonIcon } from "../../assets/icons/go-hire-icons";

import RequestsType from "./RequestsType";
import RequestsListing from "./RequestsListing";
import ServicesRequestsType from "./ServicesRequestsType";
import ServicesRequestsTabsNavigation from "./ServicesRequestsTabsNavigation";
import ProgramsRequestsTabsNavigation from "./ProgramsRequestsTabsNavigation";

const MyServices = () => {
  const { t, i18n } = useTranslation("goService", { keyPrefix: "myRequestsPage" });
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "services";

  return (
    <Box sx={styles.container}>
      <Box sx={styles.box}>
        <Typography sx={styles.title}>
          <IconButton size="small" onClick={handleBack}>
            <ArrowBackButtonIcon />
          </IconButton>
          {t("goServicesRequests")}
        </Typography>
        <RequestsType />
        {type === "services" && <ServicesRequestsType />}
        {type === "services" && <ServicesRequestsTabsNavigation />}
        {type === "programs" && <ProgramsRequestsTabsNavigation />}
        <RequestsListing />
      </Box>
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <AdvertisementCol />
      </Box>
    </Box>
  );
};

export default MyServices;

const styles = {
  container: {
    display: "flex",
    gap: "16px",
  },
  box: {
    height: "fit-content",
    width: { xs: "100%", lg: "636px" },
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    padding: "20px",
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
  },
};
